import { render, staticRenderFns } from "./JobSettingsForm.vue?vue&type=template&id=4d5060cc&"
import script from "./JobSettingsForm.vue?vue&type=script&lang=js&"
export * from "./JobSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports